/**
 * An explicit zero is a terminal sample for a drained queue. Carry it across
 * empty buckets until the next observed sample; a non-zero sample ends the fill.
 */
export const getSampledMaxBucketValue = (
  metric_values: number[],
  previous_value?: string | number,
): number => {
  if (metric_values.length > 0) {
    return Math.max(...metric_values);
  }

  return previous_value !== undefined && Number(previous_value) === 0 ? 0 : Number.NaN;
};
